import lpApp from '../lp_app';
import {
  lpIdGetCopy,
  lpIdGetPure,
  getOptionPass,
} from '../../logic/global_getter';
import {
  lpGetOptionById,
} from '../../logic/re_index';
import {
  generateId1,
} from '../../components/utils/misc';
import {
  initOutputOption,
  editOption,
  initOutputVariable,
  editVariable,
} from '../../redux/actions/output';
import ConditionsEvo from '../../logic/condition_evo';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/initialization.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

function filterRadios(siblings = []) {
  return siblings.filter(idx => lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'radio');
}
class LpOpsInitializations {
  initializeOptions(opts, dispatch, getState) {
    opts.forEach((idx) => {
      if ((lpApp.references.options
        && idx in lpApp.references.options
        && lpApp.references.getOption(idx).meta
        && (lpApp.references.getOption(idx).meta.type === 'static'
          || lpApp.references.getOption(idx).meta.type === 'hidden'))
        || lpApp.references.getOption(idx).meta.type === 'radio'
      ) {
        // radio_group.push(idx);
        const dValue = lpApp.references.getOption(idx).meta.default;
        const { children } = lpApp.references.getOption(idx);
        // test cnditions before doing any fuckedup move.
        let pass = true;
        if (lpApp.references.getOption(idx).meta.conditional) {
          if (lpApp.indexes.conditions.conditions) {
            if ((typeof lpApp.indexes.conditions.getCondition(idx) === 'undefined') && (lpApp.references.getOption(idx).meta.compiledConditions.length > 0)) {
              pass = ConditionsEvo.getCondition(idx);
              window.nbr_forced += 1;
              lpApp.indexes.conditions.setCondition(idx, pass);
            } else {
              pass = lpApp.indexes.conditions.getCondition(idx);
            }
          }
          //
        }
        // if(idx == 296)debugger;
        if (pass
          && lpApp.references.options
          && dValue in lpApp.references.options
          && lpApp.references.getOption(dValue).meta
          && lpApp.references.getOption(dValue).meta.type === 'radio'
        ) {
          // get all radios
          if (!LpOpsInitializations.isInitialized(children, getState().output.o)) {
            // dispatch(checkRadio1(dValue, idx));
            // rsRegisterAction(dValue, idx, false, -2);
          }
        }
        if (lpApp.references.getOption(idx).children.length > 0) {
          LpOpsInitializations.initializaChildren(children, dispatch);
          this.initializeOptions(lpApp.references.getOption(idx).children, dispatch, getState);
        }
      }
    });
  }

  static isInitialized(rs = [], options = []) {
    let result = false;
    rs.forEach((idx) => {
      options.forEach((jdx) => {
        if (jdx.id === idx) {
          if (jdx.value) {
            result = true;
          }
        }
      });
    });
    return result;
  }

  static initializaChildren(opts, dispatch) {
    // debugger;
    opts.forEach((idx) => {
      if (typeof lpGetOptionById(idx) === 'undefined') {
        const uiid = generateId1(1);
        const optType = lpApp.references.getOption(lpIdGetPure(idx)).meta.type;
        // Checking value
        const { value } = lpApp.indexes.options.getOption(lpIdGetPure(idx));

        if (optType === 'static' || optType === 'hidden') {
          dispatch(initOutputOption(idx, uiid, true));
        } else {
          dispatch(initOutputOption(idx, uiid, value));
        }
      } else {
        const s = lpGetOptionById(idx);
        if (typeof s.value !== 'undefined') {
          dispatch(editOption(idx, s.value));
        }
      }
    });
  }

  static lpCheckCondition(idx) {
    let pass = true;
    if (lpApp.references.getOption(lpIdGetPure(idx)).meta.conditional) {
      if ((typeof lpApp.indexes.conditions.getCondition(lpIdGetPure(idx)) === 'undefined') && (lpApp.references.getOption(lpIdGetPure(idx)).meta.compiledConditions.length > 0)) {
        pass = ConditionsEvo.getCondition(idx);
        lpApp.indexes.conditions.setCondition(lpIdGetPure(idx), pass);
      } else {
        pass = lpApp.indexes.conditions.getCondition(lpIdGetPure(idx));
      }
      //
    }
    return pass;
  }

  static initializeOneOption(idx) {
    let dValue = -1;
    const here = lpApp.references.getOption(lpIdGetPure(idx));
    if (here.meta.default) {
      dValue = here.meta.default;
    }
    lpApp.references.getOption(lpIdGetPure(idx)).children.forEach((jdx) => {
      const now = lpApp.references.getOption(lpIdGetPure(jdx));
      //
      if (now && (now.meta.type === 'radio' || now.meta.type === 'checkbox')) {
        // do the test if it's copy or not
        let nowJdx;
        if (lpIdGetCopy(idx) === -2) nowJdx = jdx;
        else nowJdx = `${jdx}_${lpIdGetCopy(idx)}`;

        const s = getOptionPass(nowJdx);
        if (typeof s !== 'undefined' && s) {
          dValue = nowJdx;
        }
      }
    });
    // console.log(dValue)
    if (dValue < 0) {
      // debugger;
      const now = lpApp.references.getOption(lpIdGetPure(idx));
      if (now.meta.type === 'radio' || now.meta.type === 'checkbox') {
        const s = getOptionPass(idx);
        //
        if (typeof s !== 'undefined' && s) {
          dValue = idx;
        }
      }
    }
    // if(typeof idx == 'string')debugger;
    return dValue;
  }

  static createMoreChildren(children, dispatch) {
    LpOpsInitializations.initializaChildren(children, dispatch);
  }

  intiialize(opts, secondLevel = false) {
    const { dispatch, getState } = lpApp;
    // console.time("init_opts");

    if (!opts) return;
    opts.forEach((idx) => {
      let dValue = -1;
      let children = [];
      let pass = true;
      if (lpIdGetCopy(idx) === -2) ({ children } = lpApp.references.getOption(lpIdGetPure(idx)));
      else {
        children = lpApp.references.getOption(lpIdGetPure(idx)).children.map(i => `${i}_${lpIdGetCopy(idx)}`);
      }

      if ((lpApp.references.options
        && lpIdGetPure(idx) in lpApp.references.options
        && lpApp.references.getOption(lpIdGetPure(idx)).meta
        && (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'static'
            || lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'hidden'))
        || (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'radio')
        || (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox')
      ) {
        // give em an initializer

        dValue = LpOpsInitializations.initializeOneOption(idx);
        if (lpIdGetCopy(idx) !== -2 && dValue > -1) dValue = `${lpIdGetPure(dValue)}_${lpIdGetCopy(idx)}`;

        // Making sure the option has no value
        children.forEach((cdx) => {
          if (lpApp.indexes.options.getOption(cdx).value) dValue = -1;
        });

        // console.log(dValue)
        if (dValue >= 0) {
          // test cnditions before doing any fuckedup move.

          if (typeof lpApp.indexes.conditions.getCondition(lpIdGetPure(idx)) === 'undefined') {
            pass = LpOpsInitializations.lpCheckCondition(idx);
          } else {
            pass = lpApp.indexes.conditions.getCondition(lpIdGetPure(idx));
          }

          // if(idx == 27)debugger;
          if (pass
            && lpApp.references.options
            && lpIdGetPure(idx) in lpApp.references.options
            && lpApp.references.getOption(lpIdGetPure(idx)).meta
            && lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox'
          ) {
            dispatch(editOption(idx, getOptionPass(idx)));
          }
          if (pass
            && lpApp.references.options
            && lpIdGetPure(dValue) in lpApp.references.options
            && lpApp.references.getOption(lpIdGetPure(dValue)).meta
            && lpApp.references.getOption(lpIdGetPure(dValue)).meta.type === 'radio'
          ) {
            // converting the lp_parenting into lp_grandpa
            if (
              !LpOpsInitializations.isInitialized(filterRadios(children), getState().output.o)
              && lpApp.indexes.grandpa.getFather(lpIdGetPure(dValue))
            ) {
              LpOpsInitializations.createMoreChildren(children, getState);
            }
          } else {
            // checkbox selection
            if (pass
              && lpApp.references.options
              && lpIdGetPure(idx) in lpApp.references.options
              && lpApp.references.getOption(lpIdGetPure(idx)).meta
              && lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox'
            ) {
              dispatch(editOption(idx, getOptionPass(idx)));
              // console.log("initializing checkbox " + idx);
              // console.log(" = " + idx + " third ")
            } else {
              dispatch(editOption(dValue, true));
            }


            // let s = getOFirstMultipleParent(lpIdGetPure(idx));
            if (lpApp.references.getOption(lpIdGetPure(idx)).meta.multiple
              && lpIdGetCopy(idx) === -2
            ) {
              // test if it has really multiples
              // debugger;
              if (lpApp.references.getOption(lpIdGetPure(idx)).children.length > 0) {
                this.intiialize(children, true);
                // console.log(" = " + idx + " deep one ")
              }
            }
          }
        }


        if (lpApp.references.getOption(lpIdGetPure(idx)).meta.multiple
          && (lpIdGetCopy(idx) === -2)
        ) {
          // test if it has really multiples
          // debugger;
          if (typeof lpApp.indexes.multiples.multiples !== 'undefined' && lpIdGetPure(idx) in lpApp.indexes.multiples.multiples) {
            const copies = lpApp.indexes.multiples.getMultiple(lpIdGetPure(idx));
            const pureCopies = copies.map(i => `${lpIdGetPure(idx)}_${i}`);
            this.intiialize(pureCopies, true);
            // console.log(" = " + idx + " deep two ")
          }
        }
        if (lpApp.references.getOption(lpIdGetPure(idx)).children.length > 0) {
          // TODO: we have to check in this?.
          LpOpsInitializations.createMoreChildren(children, getState);

          this.intiialize(children, true);
          // console.log(" = " + idx + " deep one ")
        }
      }
    });
    this.initializeVariables(opts.filter(idx => !lpApp.indexes.options.getOption(idx).value));
    if (!secondLevel) {
      lpApp.mutex.setMutex('preview', true);
    }
  }

  initializeVariables(opts) {
    const { dispatch } = lpApp;
    opts.forEach((idx) => {
      // if(typeof lpGetVariableById(idx) != 'undefined')return;
      // initialize variables.
      if (typeof lpApp.references.getOption(lpIdGetPure(idx)) === 'undefined') return;
      const { variables } = lpApp.references.getOption(lpIdGetPure(idx));
      variables.forEach((l) => {
        // if(window.lp_vars[l]){
        if (lpIdGetCopy(idx) === -2) {
          const v = lpApp.indexes.variables.getVariable(l);
          // let k = generateId1(4);
          if (v) {
            dispatch(initOutputVariable(l, idx, v.value));
            dispatch(editVariable(l, v.value));
          }
        } else {
          const v = lpApp.indexes.variables.getVariable(`${l}_${lpIdGetCopy(idx)}`);
          // let k = generateId1(4);
          if (v) {
            dispatch(initOutputVariable(`${l}_${lpIdGetCopy(idx)}`, idx, v.value));
            dispatch(editVariable(`${l}_${lpIdGetCopy(idx)}`, v.value));
          }
        }
      });
      const { children } = lpApp.references.getOption(lpIdGetPure(idx));

      // the children

      let childrenChanged;
      if (lpIdGetCopy(idx) !== -2) { // manage the muyltiples
        childrenChanged = children.map(k => `${k}_${lpIdGetCopy(idx)}`);
      } else {
        childrenChanged = children.map(k => k);
      }
      // TODO:

      this.initializeVariables(
        childrenChanged.filter(jdx => !lpApp.indexes.options.getOption(jdx).value),
      );
    });
  }

  raNextInit(sectionNumber) {
    return (dispatch, getState) => {
      const theSection = getState().contract.sections[sectionNumber];

      if (theSection) {
        lpApp.ops.initialization.initializeOptions(theSection.options, dispatch, getState);
      }
    };
  }
}


export default LpOpsInitializations;



// WEBPACK FOOTER //
// ./src/app/ops/initialization.js